import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ROUTE_DXTER_SCANNING,
  Dexter_Splash3,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
} from "../../Routes";
import LogoutModal from "../../Components/LogoutModal";
import "../../style/Purchase.scss"

const SIPConfirmationLink = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { reason } = location.state || {};
  console.log(reason);
  const [showModal, setShowModal] = useState(false);

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(Dexter_Splash3);
  };
  const HandleSubmit = () => {
    Navigate(ROUTE_DXTER_SCANNING);
  };
  return (
    <div className="Pan_Main_Container">
      <div className="Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
      </div>
      <div className="BlankText_Screen_Container">
        <p className="Input_Heading_text_SIP_Screen">
          Please click on the SIP Confirmation Link shared by NSE with you via
          SMS and/or Email. 
        </p>
        <p className="Input_Heading_text">
          Waiting for SIP confirmation from your side...{" "}
        </p>
        <button className="Submit_button" onClick={HandleSubmit}>
          Proceed to My Portfolio
        </button>
      </div>
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      ;
    </div>
  );
};

export default SIPConfirmationLink;
